import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDwergsein = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9ZM14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 20C8.65685 20 10 18.6569 10 17C10 15.3431 8.65685 14 7 14C5.34315 14 4 15.3431 4 17C4 18.6569 5.34315 20 7 20ZM7 19C8.10457 19 9 18.1046 9 17C9 15.8954 8.10457 15 7 15C5.89543 15 5 15.8954 5 17C5 18.1046 5.89543 19 7 19Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14C18.6569 14 20 15.3431 20 17ZM19 17C19 18.1046 18.1046 19 17 19C15.8954 19 15 18.1046 15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.9999 2C9.00222 2 -0.837935 18.3158 1.30165 20.4211C3.44123 22.5263 20.5586 22.5263 22.6983 20.4211C24.838 18.3158 14.9976 2 11.9999 2ZM3.02745 20.1518C2.43427 19.9789 2.13985 19.8187 2.0313 19.7329L2.03081 19.7311C2.02018 19.6937 1.97481 19.5341 2.01828 19.1328C2.07585 18.6014 2.26597 17.8782 2.5881 16.9984C3.22823 15.2502 4.3193 13.0709 5.5851 10.93C6.84958 8.79137 8.26293 6.7342 9.52894 5.22489C10.1641 4.46763 10.7405 3.87456 11.224 3.47997C11.4656 3.28284 11.6632 3.15254 11.8152 3.07528C11.9209 3.02158 11.9802 3.00598 11.9999 3.00157C12.0197 3.00598 12.0789 3.02158 12.1846 3.07528C12.3367 3.15254 12.5342 3.28284 12.7758 3.47997C13.2594 3.87456 13.8357 4.46764 14.4709 5.2249C15.737 6.7342 17.1503 8.79138 18.4148 10.93C19.6807 13.0709 20.7717 15.2502 21.4119 16.9984C21.734 17.8782 21.9241 18.6014 21.9817 19.1328C22.0252 19.5341 21.9798 19.6937 21.9692 19.7311L21.9687 19.7328C21.8601 19.8187 21.5657 19.9789 20.9725 20.1518C20.3609 20.3301 19.5618 20.4864 18.6188 20.6143C16.7366 20.8698 14.3765 21 11.9999 21C9.62336 21 7.26328 20.8698 5.3811 20.6143C4.43814 20.4864 3.63904 20.3301 3.02745 20.1518Z'
    />
  </svg>
);
export default SvgDwergsein;
